export default __webpack_public_path__ + "static/media/prd6.de37255b.jpg";